import { Route } from '@angular/router';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { AdminRoleGuard } from './core/auth/guards/AdminRoleGuard';
import { UnauthorizedComponent } from './modules/auth/unauthorized/unauthorized.component';

export const appRoutes: Route[] = [
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'onboarding',
                loadChildren: () =>
                    import('app/modules/onbording/onbording.routing'),
            },
            // Hidden 20-Oct-2026: no menu item or link reaches this page and its form cannot save
            // (it sends no line-of-business code, which Onboarding/Add requires). Kept for reference.
            // {
            //     path: 'crm-onboarding',
            //     loadChildren: () =>
            //         import(
            //             'app/modules/crm-onboarding/crm-onboarding/crm-onboarding.routing'
            //         ),
            // },
            {
                path: 'generate-password',
                loadChildren: () =>
                    import(
                        'app/modules/central-auth/generate-password.routing'
                    ),
            },
            {
                path: 'unauthorized', component: UnauthorizedComponent
            },
        ],
    },
    {
        path: '',
        canActivate: [AdminRoleGuard],
        component: LayoutComponent,
        data: {
            layout: 'classic',
        },
        children: [
            {
                path: 'dashboard',
                loadChildren: () =>
                    import('app/modules/dashboard/dashboard.routing'),
            },
            {
                path: 'scope',
                loadChildren: () => import('app/modules/scope/scope.routing'),
            },
            {
                path: 'region',
                loadChildren: () => import('app/modules/region/region.routing'),
            },
            {
                path: 'application',
                loadChildren: () =>
                    import('app/modules/application/application.routes'),
            },
            // Hidden 20-Oct-2026: only this page edited the country list (4 seeded rows); the list itself is still
            // used (addresses, customers, the Region form's dropdown), so the table and its dropdown call stay.
            // {
            //     path: 'country',
            //     loadChildren: () =>
            //         import('app/modules/country/country.routing'),
            // },
            // Hidden 20-Oct-2026: nothing reads the role list this page edits - a user's role comes from
            // pe_users.role_id through the fixed Role list in the code, and that is what the login token carries.
            // {
            //     path: 'role',
            //     loadChildren: () => import('app/modules/role/role.routing'),
            // },
            {
                path: 'postcode',
                loadChildren: () =>
                    import('app/modules/postcode/postcode.routing'),
            },
            {
                path: 'user',
                loadChildren: () => import('app/modules/user/user.routing'),
            },
            {
                path: 'pe-lob',
                loadChildren: () => import('app/modules/pe-lob/pe-lob.routing'),
            },
            {
                path: 'meter-points',
                loadChildren: () =>
                    import('app/modules/meter-points/meter-points.routing'),
            },
        ],
    },

    { path: '**', pathMatch: 'full', redirectTo: 'dashboard' },
];
